'use strict';
import WOW from 'wow.js';
import Swiper, {Autoplay, EffectFade, Grid, Lazy, Navigation, Pagination, Parallax, Thumbs} from 'swiper';
import scrollSpy from 'simple-scrollspy';

import 'swiper/modules/effect-fade/effect-fade.scss';
import 'swiper/modules/navigation/navigation.scss';
import 'swiper/modules/autoplay/autoplay.scss';
import 'swiper/modules/pagination/pagination.scss';
import 'swiper/modules/parallax/parallax.scss';
import 'swiper/modules/grid/grid.scss';
import 'swiper/modules/lazy/lazy.scss';

(function($) {

  const wenpriseElementor = {};

  wenpriseElementor.init = function() {
    this.slider();
    this.wow();
  };

  /**
   * Scroll nav sticky
   */
  wenpriseElementor.navSticky = function() {
    const navToStick = document.getElementById('rs-scroll-nav');
    const body = document.getElementsByTagName('body')[0];

    if (navToStick) {
      const sticky = navToStick.offsetTop + 100;

      if (window.scrollY > sticky) {
        navToStick.classList.add('is-sticky');
        body.classList.add('is-sticky');
      } else {
        navToStick.classList.remove('is-sticky');
        body.classList.remove('is-sticky');
      }
    }
  };

  /**
   * ScrollSpy
   */
  wenpriseElementor.scrollSpy = function() {
    if (document.getElementsByClassName('rs-scroll-nav').length > 0) {
      scrollSpy('.rs-scroll-nav', {
        sectionClass    : '.elementor-top-section',
        menuActiveTarget: 'li > a',
        offset          : 100,
        smoothScroll    : false,
      });
    }

  };

  wenpriseElementor.slider = function() {

    /*---------------------
    Main Slider
    -----------------------*/
    if ($('.swiper-main-slider').length !== 0) {
      //Slider Animated Caption
      var swiper = new Swiper('.swiper-container-main', {
        modules            : [Navigation, Pagination, Autoplay, Lazy],
        navigation         : {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        slidesPerView      : 3,
        pagination         : {
          el            : '.swiper-pagination',
          dynamicBullets: true,
        },
        paginationClickable: true,
        nextButton         : '.swiper-button-next',
        prevButton         : '.swiper-button-prev',
        spaceBetween       : 24,
        loop               : true,
        simulateTouch      : true,
        autoplay           : 3000,
        speed              : 1000,
      });
    }

    /*---------------------
    Main Slider Fade Effect
    -----------------------*/
    if ($('.swiper-main-slider-fade').length !== 0) {
      //Slider Animated Caption
      let swiper = new Swiper('.swiper-container-fade', {
        modules            : [Navigation, Pagination, Autoplay, Grid, Parallax, EffectFade, Thumbs, Lazy],
        effect             : 'fade',
        navigation         : {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination         : {
          el            : '.swiper-pagination',
          dynamicBullets: true,
        },
        paginationClickable: true,
        nextButton         : '.swiper-button-next',
        prevButton         : '.swiper-button-prev',
        spaceBetween       : 0,
        loop               : true,
        simulateTouch      : true,
        autoplay           : 5000,
        speed              : 1000,
        on                 : {
          slideChange: function(swiper) {
            $('.swiper-slide').each(function() {
              if ($(this).index() === swiper.activeIndex) {
                // Fadein in active slide
                $(this).find('.slider-content').fadeIn(300);
              } else {
                // Fadeout in inactive slides
                $(this).find('.slider-content').fadeOut(300);
              }
            });
          },
        },
      });
    }

    /*---------------------
    Parallax Slider
    -----------------------*/
    if ($('#swiper-parallax').length !== 0) {
      var swiper = new Swiper('.swiper-container-parallax', {
        parallax           : true,
        navigation         : {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination         : {
          el            : '.swiper-pagination',
          dynamicBullets: true,
        },
        paginationClickable: true,
        nextButton         : '.swiper-button-next',
        prevButton         : '.swiper-button-prev',
        spaceBetween       : 0,
        loop               : false,
        simulateTouch      : true,
        autoplay           : false,
        speed              : 1000,
      });
    }
  };

  wenpriseElementor.wow = function() {
    new WOW().init();
  };

  $(document).ready(function() {
    wenpriseElementor.init();
  });

  window.onload = function() {
    wenpriseElementor.scrollSpy();
  };

  window.onscroll = function() {
    wenpriseElementor.navSticky();
  };

})(jQuery);
